<div class="pm-v2-page">
  <div class="card card-statistics mb-30"><div class="card-body">
    <h4 class="mb-0">ویرایش الگوی PM V2</h4>
  </div></div>


  <form [formGroup]="Form" (ngSubmit)="Save()">
    <div class="card card-statistics mb-30">
      <div class="card-header">
        <strong>مشخصات الگو</strong>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-md-3 form-group">
            <label>کد PM *</label>
            <input type="text" class="form-control" formControlName="PM_Code">
          </div>

          <div class="col-md-5 form-group">
            <label>عنوان PM *</label>
            <input type="text" class="form-control" formControlName="PM_Title">
          </div>

          <div class="col-md-2 form-group">
            <label>Version *</label>
            <input type="number" min="1" class="form-control" formControlName="Version">
          </div>

          <div class="col-md-2 form-group">
           <label>زمان تقریبی (دقیقه)</label>
            <input type="number" min="0" class="form-control" formControlName="Time_Estimated">
          </div>

          <div class="col-md-12 form-group">
            <label>توضیحات</label>
            <textarea rows="3" class="form-control" formControlName="Description"></textarea>
          </div>

          <div class="col-md-3 form-group" style="display: none;">
            <div class="custom-control custom-checkbox mt-4">
              <input
                type="checkbox"
                class="custom-control-input"
                id="PM_V2_Status"
                formControlName="Status">
              <label class="custom-control-label" for="PM_V2_Status">فعال</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card card-statistics mb-30">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-6">
            <strong>آیتم‌های PM</strong>
          </div>
          <div class="col-sm-6 text-left">
            <button type="button" class="btn btn-success" (click)="AddItem()">
              افزودن آیتم
            </button>
          </div>
        </div>
      </div>

      <div class="card-body border-bottom">
        <div class="row">
          <div class="col-md-12"><strong>تنظیمات پیش‌فرض آیتم جدید</strong></div>
          <div class="col-md-3 form-group">
            <label>دوره پیش‌فرض (روز)</label>
            <input type="number" min="1" class="form-control" formControlName="Default_Frequency">
          </div>
          <div class="col-md-3 form-group">
            <label>هشدار پیش‌فرض قبل از موعد (روز)</label>
            <input type="number" min="0" class="form-control" formControlName="Default_Warning_Days">
          </div>
          <div class="col-md-6 form-group pt-4">
            <small class="text-muted">این مقادیر فقط برای آیتم‌های جدید اعمال می‌شوند و آیتم‌های قبلی را تغییر نمی‌دهند.</small>
          </div>
        </div>
      </div>

      <div class="card-body" formArrayName="items">
        <div
          class="card card-statistics mb-30"
          *ngFor="let item of Items.controls; let i = index"
          [formGroupName]="i">

          <div class="row" style="padding: 10px;">
            <div class="col-md-6 form-group">
              <strong>آیتم {{ i + 1 }}</strong>
            </div>
            <div class="col-md-6 form-group text-left">
              <button type="button" class="btn btn-info ml-2" style="margin-left: 5px;"  [disabled]="i === 0" (click)="MoveItemUp(i)">
                <i class="fa fa-arrow-up"></i> بالا
              </button>
              <button type="button" class="btn btn-info" style="margin-left: 5px;"  [disabled]="i === Items.length - 1" (click)="MoveItemDown(i)">
                <i class="fa fa-arrow-down"></i> پایین
              </button>
            </div>

            <div class="col-md-5 form-group">
              <label>عنوان فعالیت *</label>
              <input type="text" class="form-control" formControlName="Title_Item">
            </div>

            <div class="col-md-2 form-group">
              <label>نوع نتیجه *</label>
              <select class="custom-select"  formControlName="Type_Item">
                <option *ngFor="let type of TypeList" [value]="type">{{ type }}</option>
              </select>
            </div>

            <div class="col-md-2 form-group">
              <label>دوره (روز) *</label>
              <input type="number" min="1" class="form-control" formControlName="Value_Frequency">
            </div>

            <div class="col-md-2 form-group">
              <label>هشدار قبل از موعد</label>
              <input type="number" min="0" class="form-control" formControlName="Days_Warning">
            </div>

            <div class="col-md-1 form-group text-center">
              <label>اجباری</label>
              <div>
                <input type="checkbox" formControlName="Required_Is">
              </div>
            </div>

            <div class="col-md-6 form-group">
              <label>معیار پذیرش</label>
              <textarea class="form-control" rows="2" formControlName="Criteria_Acceptance"></textarea>
            </div>

            <div class="col-md-5 form-group">
              <label>دستور انجام</label>
              <textarea class="form-control" rows="2" formControlName="Instruction"></textarea>
            </div>

            <div class="col-md-1 form-group text-center">
              <label>فعال</label>
              <div>
                <input type="checkbox" formControlName="Active">
              </div>
            </div>

            <div class="col-md-12 text-left">
              <button type="button" class="btn btn-danger" (click)="RemoveItem(i)">
                حذف / غیرفعال
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-left mb-4">
      <button type="button" style="margin-left: 5px;"  class="btn btn-warning ml-2" (click)="Cancel()"><i class="fa fa-mail-reply"></i> بازگشت</button>
      <button type="submit" style="margin-left: 5px;"  class="btn btn-success" [disabled]="Procssing">
        {{ Procssing ? 'در حال ثبت...' : 'ثبت اطلاعات' }}
      </button>
    </div>
  </form>
</div>
